"use client";

import { useState } from "react";
import { Check, Link2 } from "lucide-react";

/**
 * "Bağlantıyı kopyala" dugmesi. Tek istemci parcasi: panoya yazmak tarayici
 * API'si ister; ShareLinks'in geri kalani sunucu bileseni olarak kalir.
 */
export default function ShareCopyButton({ url, className }: { url: string; className?: string }) {
  const [copied, setCopied] = useState(false);

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      window.setTimeout(() => setCopied(false), 2000);
    } catch {
      setCopied(false);
    }
  };

  return (
    <button type="button" onClick={() => void copy()} className={className} aria-label="Bağlantıyı kopyala" aria-live="polite">
      {copied ? <Check className="h-4 w-4" aria-hidden="true" /> : <Link2 className="h-4 w-4" aria-hidden="true" />}
      <span>{copied ? "Kopyalandı" : "Bağlantıyı kopyala"}</span>
    </button>
  );
}
